<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import BcSelect from '~/ui/Select/BcSelect.vue'

interface IProps {
  modelValue: number
  options?: number[]
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: 25,
  options: () => []
})

const emits = defineEmits([ 'update:modelValue', 'goFirstPage' ])

const value = useVModel(props, 'modelValue')

const paginationOptionList = computed(() => {
  return props.options.map(option => {
    return {
      label: option.toString(),
      value: option,
    }
  })
})
</script>

<template>
  <BcSelect
    v-model="value"
    :options="paginationOptionList"
    @change="emits('goFirstPage')"
  />
</template>

<style scoped lang="scss">
</style>